import getAxiosInstance from '../../config/api';
import qs from 'qs';
import type { NextApiRequest } from 'next';
import _ from 'lodash';
import type { ShopConfig } from 'domain-model/types/supplier-gateway';
import type { Article } from 'domain-model/types/oms';

export const getMyFavoritesList = async (
  sessionUser: any,
  shopConfig: ShopConfig,
  req: NextApiRequest,
) => {
  try {
    const axiosInstance = await getAxiosInstance(req);
    const activeMembership = sessionUser?.activeMembership;
    const myPurchaseListQuery = {
      query: {
        customerSubUnit: activeMembership.customerSubUnit
          ? activeMembership.customerSubUnit.id
          : '<NULL>',
        supplierCustomer: activeMembership.supplierCustomer
          ? activeMembership.supplierCustomer.id
          : '<NULL>',
        owningSupplierOrganizationId: shopConfig.organization
          ?.usesSupplierCustomer
          ? shopConfig.organization.id
          : '<NULL>',
        shopConfigId: shopConfig.id,
        name: 'Mina favoriter',
      },
      cacheBuster: new Date().getTime(),
    };
    const myPurchaseLists = await axiosInstance.get(
      `/purchaseLists?${qs.stringify(myPurchaseListQuery)}`,
    );
    const myPurchaseListId = _.get(myPurchaseLists, 'data.rows[0].id');
    if (!myPurchaseListId) {
      return null;
    }
    return await axiosInstance.get(`/purchaseLists/${myPurchaseListId}`);
  } catch (error) {
    console.error(error);
    return;
  }
};

export function addFavoriteArticle(article: Article) {
  return async function (dispatch: Function) {
    await dispatch({
      type: 'ADD_FAVORITE_ARTICLE',
      payload: { article },
    });
  };
}

export function removeFavoriteArticle(article: Article) {
  return async function (dispatch: Function) {
    await dispatch({
      type: 'REMOVE_FAVORITE_ARTICLE',
      payload: { article },
    });
  };
}

export const loadMyFavoriteArticles =
  (req: NextApiRequest) => async (dispatch: Function, getState: Function) => {
    const { shopConfig, authentication } = getState();
    const { sessionUser } = authentication;

    if (!sessionUser) return;

    const myFavorites = await getMyFavoritesList(sessionUser, shopConfig, req);
    const purchaseListId = _.get(myFavorites, 'data.id');
    if (purchaseListId !== undefined) {
      dispatch({
        type: 'LOAD_MY_FAVORITE_ARTICLES',
        payload: {
          total: _.get(myFavorites, 'data.purchaseListItems', []).length,
          purchaseListId,
          articles: _.get(myFavorites, 'data.purchaseListItems', []).map(
            (x: Article) => x.article,
          ),
        },
      });
    }
  };

export const clearMyFavoriteArticles = () => async (dispatch: Function) => {
  await dispatch({
    type: 'CLEAR_MY_FAVORITE_ARTICLES',
    payload: {},
  });
};
